import { useState } from "react";
import { Head, useForm } from "@inertiajs/react";

import Button from "/components/Button";
import Switch from "/components/Switch";
import TextField from "/components/TextField";

import styles from "./Index.module.css";

export default function LinksIndex({
  info_links,
  contact_links,
}) {
  const initialInfoLinksData = info_links.reduce(
    (result, currentItem) => (result[currentItem.key] = currentItem) && result,
    {}
  );
  const initialContactLinksData = contact_links.reduce(
    (result, currentItem) => (result[currentItem.key] = currentItem) && result,
    {}
  );
  const [infoLinks, setInfoLinks] = useState(initialInfoLinksData);
  const [contactLinks, setContactLinks] = useState(initialContactLinksData);

  const handleInfoLinksChange = (key, newLink) => {
    setInfoLinks({ ...infoLinks, [key]: { ...infoLinks[key], ...newLink } });
  };

  const handleContactLinksChange = (key, newLink) => {
    setContactLinks({ ...contactLinks, [key]: { ...contactLinks[key], ...newLink } });
  };

  // Both tables hold the same rows, so they share their column widths too.
  const columns = (
    <colgroup>
      <col />
      <col />
      <col />
      <col className={styles.switchColumn} />
      <col className={styles.actionsColumn} />
    </colgroup>
  );

  return (
    <>
      <Head>
        <title>Подвал</title>
      </Head>

      <div className="table-header">
        <div className="table-header__left">
          <h2>Подвал</h2>
        </div>
      </div>

      <table className="tbl tbl--fixed">
        {columns}
        <thead>
          <tr>
            <th>Левый блок / Пункты</th>
            <th>Items</th>
            <th>Ссылка</th>
            <th>Показать</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(infoLinks).map((key) => (
            <LinkItem item={infoLinks[key]} onChange={handleInfoLinksChange} />
          ))}
        </tbody>
      </table>

      <hr />

      <table className="tbl tbl--fixed">
        {columns}
        <thead>
          <tr>
            <th>Правый блок / Соцсети</th>
            <th>Items</th>
            <th>Ссылка</th>
            <th>Показать</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(contactLinks).map((key) => (
            <LinkItem item={contactLinks[key]} onChange={handleContactLinksChange} />
          ))}
        </tbody>
      </table>
    </>
  );
};

function LinkItem({
  item,
  onChange,
}) {
  const { data, setData, put, reset, errors } = useForm({
    title_ru: item.title_ru,
    title_en: item.title_en,
    value: item.value,
    display: item.display
  });
  const [editMode, setEditMode] = useState(false);

  const handleEdit = () => {
    setEditMode(true);
  };

  const handleSubmit = () => {
    put(
      `/admin/links/${item.id}`,
      {
        preserveScroll: true,
        preserveUrl: true,
        only: ["updated_item"],
        onSuccess: (response) => {
          onChange(item.key, response.props.updated_item);
          setEditMode(false);
        },
      }
    );
  };

  const handleCancel = () => {
    reset();
    setEditMode(false);
  };

  return !editMode ? (
    <tr>
      <td>{item.title_ru}</td>
      <td>{item.title_en}</td>
      <td>{item.value}</td>
      <td>
        <Switch
          value={item.display}
          name="display"
          url={`/admin/links/${item.id}`}
          onChange={(data) => onChange(item.key, data)}
        />
      </td>
      <td className="tbl-extra">
        <div className="tbl-actions tbl-actions--hiding">
          <Button className="lnk lnk--blue" onClick={handleEdit}>Редактировать</Button>
        </div>
      </td>
    </tr>
  ) : (
    <tr className="tbl-form-row">
      <td>
        <TextField
          value={data.title_ru}
          placeholder="Пункт"
          onChange={value => setData("title_ru", value)}
          errors={errors.title_ru}
        />
      </td>
      <td>
        <TextField
          value={data.title_en}
          placeholder="Item"
          onChange={value => setData("title_en", value)}
          errors={errors.title_en}
        />
      </td>
      <td>
        <TextField
          value={data.value}
          placeholder="Ссылка"
          onChange={value => setData("value", value)}
          errors={errors.value}
        />
      </td>
      <td>
        <Switch
          value={item.display}
          name="display"
          url={`/admin/links/${item.id}`}
          onChange={(data) => onChange(item.key, data)}
        />
      </td>
      <td className="tbl-extra">
        {/* Grouped, so space-between doesn't fling them to the ends of a column
            that's wider than they are. */}
        <div className="tbl-actions">
          <div className="flex-row gap-3">
            <Button className="lnk lnk--green" onClick={handleSubmit}>Сохранить</Button>
            <Button className="lnk" onClick={handleCancel}>Отменить</Button>
          </div>
        </div>
      </td>
    </tr>
  );
};
